import axios from 'axios';

// const IGNORE_METHODS = ['get', 'head', 'options'];

axios.defaults.withCredentials = true;

const BASE_URL = process.env.REACT_APP_API_BASE || 'api';

// Store CSRF token in memory
let csrfToken = null;

const apis = {
    user: axios.create({ baseURL: BASE_URL + '/users' }),
    article: axios.create({ baseURL: BASE_URL + '/articles' }),
    articleTypes: axios.create({ baseURL: BASE_URL + '/articleTypes' }),
    image: axios.create({ baseURL: BASE_URL + '/images' }),
    page: axios.create({ baseURL: BASE_URL + '/pages' }),
    axios: axios.create({ baseURL: BASE_URL }),
};

Object.values(apis).forEach((api) => {
    api.interceptors.request.use(async (config) => {
        if (config.retag) {
            const response = await apis.axios.get('/tag');
            csrfToken = response.data.csrfToken;
        }

        if (config.validateCsrf) {
            config.headers['X-CSRF-Token'] = csrfToken;
        }

        return config;
    });
});

export default apis;
